<template>

  <div class="form">
    <div v-if="amount > 0">
      <SCAPaymentRequestButton
          :stripe-public-key="stripePublicKey"
          :stripe-account-id="stripeAccountId"
          :order-id="orderId"
          :payment-request-options="paymentRequestOptions"
          @valid="paymentRequest = true"
          @emit-global-loading="globalLoadingHandler"
          :subdomain="subdomain"
          @payment-successful="trackPayment"
      />

      <hr class="hr-text mt-3" data-content="Or pay with card" v-if="paymentRequest">
      <SCAOneOffPaymentForm
          :stripe-public-key="stripePublicKey"
          :stripe-account-id="stripeAccountId"
          :order-id="orderId"
          @emit-global-loading="globalLoadingHandler"
          :amount="paymentRequestOptions.total.amount"
          @payment-successful="trackPayment"
      />
    </div>
    <BookNowButton @emit-global-loading="globalLoadingHandler" v-else/>
  </div>

</template>

<script>

import SCAOneOffPaymentForm from './SCAOneOffPaymentForm.vue';
import SCAPaymentRequestButton from './SCAPaymentRequestButton.vue';
import BookNowButton from './BookNowButton.vue';
import track from './../ga-ecommerce-tracking';

export default {
  name: 'OneOffPayments',
  components: {
    BookNowButton,
    SCAPaymentRequestButton,
    SCAOneOffPaymentForm,
  },
  data() {
    return {
      paymentRequest: false,
    };
  },
  props: {
    stripePublicKey: {
      type: String,
      required: true,
    },
    stripeAccountId: {
      type: String,
      required: true,
    },
    orderId: {
      type: String,
      required: false,
    },
    paymentRequestOptions: {
      required: true,
      type: Object,
    },
    parentHasSubscription: {
      required: true,
      type: Boolean,
    },
    subdomain: {
      required: true,
      type: String,
    },

  },
  computed: {
    amount() {
      return this.paymentRequestOptions.total.amount;
    },
  },

  methods: {
    createPaymentRequestOptions(optionsString) {
      return JSON.parse(optionsString);
    },
    globalLoadingHandler(e) {
      this.$emit('emit-global-loading', e);
    },
    trackPayment(uuid) {
      const options = this.paymentRequestOptions;
      const client = options.total.label;
      const value = options.total.amount;
      const { currency } = options;
      track({
        client,
        value,
        currency,
        uuid,
      });
    }

  },

  created() {
  },
  mounted() {
  },
};
</script>

<style scoped lang="scss">
.form {
  background-color: #f6f9fc;
  padding: 12px;
  padding-top: 24px;
}

.hr-text {
  line-height: 1em;
  position: relative;
  outline: 0;
  border: 0;
  color: black;
  text-align: center;
  height: 1.5em;
  opacity: .5;

  &:before {
    content: '';
    // use the linear-gradient for the fading effect
    // use a solid background color for a solid bar
    background: linear-gradient(to right, transparent, #818078, transparent);
    position: absolute;
    left: 0;
    top: 50%;
    width: 100%;
    height: 1px;
  }

  &:after {
    content: attr(data-content);
    position: relative;
    display: inline-block;
    color: black;

    padding: 0 .5em;
    line-height: 1.5em;
    // this is really the only tricky part, you need to specify the background color of the container element...
    color: #2a2a2a;
    background-color: #fcfcfa;
  }
}
</style>
